/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Branches_Archive_Confirm_DescriptionInputs */

const en_branches_archive_confirm_description = /** @type {(inputs: Branches_Archive_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" will no longer be selectable for new cases. Existing cases keep their branch.`)
};

const pt_br2_branches_archive_confirm_description = /** @type {(inputs: Branches_Archive_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" não poderá mais ser selecionada para novos casos. Os casos existentes mantêm sua filial.`)
};

/**
* | output |
* | --- |
* | "\"{name}\" will no longer be selectable for new cases. Existing cases keep their branch." |
*
* @param {Branches_Archive_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_archive_confirm_description = /** @type {((inputs: Branches_Archive_Confirm_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Archive_Confirm_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_archive_confirm_description(inputs)
	return pt_br2_branches_archive_confirm_description(inputs)
});